'use strict';

/**
 * Updates active shipping row and headline after variant change.
 * @param {jQuery} $modal - modal element
 * @param {string} packingAttribute - product packing dimension value
 */
function updateHighlight($modal, packingAttribute) {
    var $highlight = $modal.find('.js-shipping-costs-highlight');
    var $value = $highlight.find('.js-shipping-costs-highlight-value');
    var $activeRow = $modal.find('.shipping-costs-modal__row').filter(function () {
        return $(this).data('packingAttribute') === packingAttribute;
    }).first();

    $modal.find('.shipping-costs-modal__row').removeClass('shipping-costs-modal__row--active');

    if ($activeRow.length) {
        $activeRow.addClass('shipping-costs-modal__row--active');
        $value.text(' ' + $activeRow.data('shippingLabel'));
        $highlight.removeClass('d-none');
    } else {
        $highlight.addClass('d-none');
        $value.text('');
    }
}

module.exports = {
    init: function () {
        var $modal = $('#shipping-costs-modal');

        if ($modal.length && !$modal.parent().is('body')) $modal.appendTo('body');

        $('body').on('show.bs.modal', '#shipping-costs-modal', function () {
            if (!$(this).parent().is('body')) $(this).appendTo('body');

            $('body').addClass('shipping-costs-modal-open');
        });

        $('body').on('hidden.bs.modal', '#shipping-costs-modal', function () {
            $('body').removeClass('shipping-costs-modal-open');
        });

        $('body').on('product:afterAttributeSelect', function (e, params) {
            if (!params.data.product || params.data.product.packingDimension === undefined) return;

            updateHighlight($('#shipping-costs-modal'), params.data.product.packingDimension);
        });
    }
};
